export enum ORCHESTRATION_STATUSES {
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  FINISHED_ERROR = 'FINISHED_ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  STOPPED = 'STOPPED',
  STOPPING = 'STOPPING',
}
